import axios from "axios";
import headers from "./Header";
let url = "/api/sds";
class SdsService {
	getDatas(endpoint, page, column, query) {
		return axios.get(url + "/" + endpoint + "?page=" + page + "&column=" + column + "&query=" + query, {
			headers: headers(),
		});
	}

	advancedSearch(page, query) {
		return axios.get(url + "/masters/advanced-search?page=" + page + "&" + query, {
			headers: headers(),
		});
	}

	getDetailData(query) {
		return axios.get(url + "/master" + query, {
			headers: headers(),
		});
	}
	getPembinaData(page, name, provinceCode, cityCode) {
		let url = "/api/pembina-data?size=10"
		url += page ? '&page='+page : "&page=0";
		if (name) {
			url = url + "&name=" + name;
		}
		if (provinceCode) {
			url = url + "&provinceCode=" + provinceCode;
		}
		if (cityCode) {
			url = url + "&cityCode=" + cityCode;
		}
		return axios.get(url, {
			headers: headers(),
		});
	}
	getProdusenData(page, name, provinceCode, cityCode) {
		let url = "/api/produsen-data?size=10"
		url += page ? '&page='+page : "&page=0";
		if (name) {
			url = url + "&name=" + name;
		}
		if (provinceCode) {
			url = url + "&provinceCode=" + provinceCode;
		}
		if (cityCode) {
			url = url + "&cityCode=" + cityCode;
		}
		return axios.get(url, {
			headers: headers(),
		});
	}
	getWalidata(page, name, provinceCode, cityCode) {
		let url = "/api/walidata?size=10"
		url += page ? '&page='+page : "&page=0";
		if (name) {
			url = url + "&name=" + name;
		}
		if (provinceCode) {
			url = url + "&provinceCode=" + provinceCode;
		}
		if (cityCode) {
			url = url + "&cityCode=" + cityCode;
		}
		return axios.get(url, {
			headers: headers(),
		});
	}
	getWalidataById(id) {
		let url = '/api/walidata/'+id
		return axios.get(url, {
			headers: headers(),
		});
	}
	getProdusenDataById(id) {
		let url = '/api/produsen-data/'+id
		return axios.get(url, {
			headers: headers(),
		});
	}
	addPembinaData(data) {
		let url = '/api/pembina-data'
		return axios.post(url, data, {
			headers: headers(),
		});
	}
	addWalidata(data) {
		let url = '/api/walidata'
		return axios.post(url, data, {
			headers: headers(),
		});
	}
	addProdusenData(data) {
		let url = '/api/produsen-data'
		return axios.post(url, data, {
			headers: headers(),
		});
	}
	
	
	updatePembinaData(data,id) {
		let url = '/api/pembina-data/'+id
		return axios.put(url, data, {
			headers: headers(),
		});
	}
	updateWalidata(data,id) {
		let url = '/api/walidata/'+id
		return axios.put(url, data, {
			headers: headers(),
		});
	}
	updateProdusenData(data,id) {
		let url = '/api/produsen-data/'+id
		return axios.put(url, data, {
			headers: headers(),
		});
	}

	deletePembinaData(id) {
		let url = '/api/pembina-data/'+id
		return axios.delete(url, {
			headers: headers(),
		});
	}
	deleteWalidata(id) {
		let url = '/api/walidata/'+id
		return axios.delete(url, {
			headers: headers(),
		});
	}
	deleteProdusenData(id) {
		let url = '/api/produsen-data/'+id
		return axios.delete(url, {
			headers: headers(),
		});
	}
	
	getSettings() {
		let url = "/api/standar-data-statistik/settings"
		return axios.get(url, {
			headers: headers(),
		});
	}
	getConceptReferenceList(name) {
		let url = "/api/standar-data-statistik/concept-references?page=0&size=10"
		if (name) {
			url = url + "&name=" + name;
		}
		return axios.get(url, {
			headers: headers(),
		});
	}
	getConceptReferenceBySubmissionId(submissionId) {
		let url = "/api/standar-data-statistik/concept-references?page=0&size=10"
		if (submissionId) {
			url = url + "&submissionId=" + submissionId;
		}
		return axios.get(url, {
			headers: headers(),
		});
	}
	getVariableReferenceList(name) {
		let url = "/api/standar-data-statistik/variable-references?page=0&size=10"
		if (name) {
			url = url + "&name=" + name;
		}
		return axios.get(url, {
			headers: headers(),
		});
	}
	getVariableReferenceBySubmissionId(submissionId) {
		let url = "/api/standar-data-statistik/variable-references?page=0&size=10"
		if (submissionId) {
			url = url + "&submissionId=" + submissionId;
		}
		return axios.get(url, {
			headers: headers(),
		});
	}
	getIndicatorReferenceList(name) {
		let url = "/api/standar-data-statistik/indicator-references?page=0&size=10"
		if (name) {
			url = url + "&name=" + name;
		}
		return axios.get(url, {
			headers: headers(),
		});
	}
	getIndicatorReferenceBySubmissionId(submissionId) {
		let url = "/api/standar-data-statistik/indicator-references?page=0&size=10"
		if (submissionId) {
			url = url + "&submissionId=" + submissionId;
		}
		return axios.get(url, {
			headers: headers(),
		});
	}

	getSdsList(period, responsibleOrganization, page, size) {
		let url = '/api/standar-data-statistik/usulan?'
		if (period) {
			url = url + "period=" + period + "&";
		}
		if (responsibleOrganization) {
			url = url + "responsibleOrganization=" + responsibleOrganization + "&";
		}
		if (page != null) {
			url = url + "page=" + page + "&";
		}
		if (size != null) {
			url = url + "size=" + size;
		}
		return axios.get(url, {
			headers: headers(),
		});
	}
	getSdsItemList(submissionPeriod, requesterOrganization, page, size) {
		let url = '/api/standar-data-statistik/usulan/items?'
		if (submissionPeriod) {
			url = url + "submissionPeriod=" + submissionPeriod;
		}
		if (requesterOrganization) {
			url = url + "&requesterOrganization=" + requesterOrganization;
		}
		if (page) {
			url = url + "&page=" + page;
		}
		if (size) {
			url = url + "&size=" + size;
		}
		return axios.get(url, {
			headers: headers(),
		});
	}
	getSdsItemListByQuery(query) {
		let url = '/api/standar-data-statistik/usulan/items?'+query
		return axios.get(url, {
			headers: headers(),
		});
	}
	getSdsItemReportByQuery(query) {
		let url = '/api/standar-data-statistik/report/items?'+query
		return axios.get(url, {
			headers: headers(),
		});
	}
	getApproverSdsItemList(approverOrganization) {
		let url = '/api/standar-data-statistik/usulan/items?approver_organization=' + approverOrganization
		return axios.get(url, {
			headers: headers(),
		});
	}
	getSdsItemListBySdsnId(sdsnId) {
		let url = '/api/standar-data-statistik-nasional/' + sdsnId + '/usulan/items'
		return axios.get(url, {
			headers: headers(),
		});
	}
	countSdsItemGroupBySdsnId() {
		let url = '/api/standar-data-statistik-nasional/usulan/items/counts'
		return axios.get(url, {
			headers: headers(),
		});
	}
	getSdsItem(sdsItemId) {
		let url = '/api/standar-data-statistik/usulan/items/' + sdsItemId
		return axios.get(url, {
			headers: headers(),
		});
	}
	getOldSdsItem(oldId) {
		let url = '/api/standar-data-statistik/usulan/old-items/' + oldId
		return axios.get(url, {
			headers: headers(),
		});
	}
	getSimilarSdsItem(sdsItemId) {
		let url = '/api/standar-data-statistik/usulan/items/' + sdsItemId + '/similarities'
		return axios.get(url, {
			headers: headers(),
		});
	}
	addSdsItem(data) {
		let url = '/api/standar-data-statistik/usulan/items'
		return axios.post(url, data, {
			headers: headers(),
		});
	}
	updateSdsItem(data, sdsItemId) {
		let url = '/api/standar-data-statistik/usulan/items/' + sdsItemId
		return axios.put(url, data, {
			headers: headers(),
		});
	}
	approvalSdsItem(data,sdsItemId) {
		let url = '/api/standar-data-statistik/approval/usulan/items/' + sdsItemId
		return axios.put(url, data, {
			headers: headers(),
		})
	}
	deleteSdsItem(sdsItemId) {
		let url = '/api/standar-data-statistik/usulan/items/' + sdsItemId
		return axios.delete(url, {
			headers: headers(),
		});
	}
	

	getSdsnDetail(id) {
		let url = '/api/standar-data-statistik-nasional/' + id;
		return axios.get(url, {
			headers: headers(),
		});
	}
	getSdsnListV2(){
		let url = '/api/v2/standar-data-statistik-nasional?'
		return axios.get(url, {
			headers: headers(),
		});
	}

	getSdsnList(idSds, noIndikator, judulIndikator, konsep, definisi, klasifikasi, ukuran, satuan, flag, page, size, sortBy) {
		let url = '/api/standar-data-statistik-nasional?'
		if (idSds) {
			url = url + "idSds=" + idSds + "&";
		}
		if (noIndikator) {
			url = url + "noIndikator=" + noIndikator + "&";
		}
		if (judulIndikator) {
			url = url + "judulIndikator=" + judulIndikator + "&";
		}
		if (konsep) {
			url = url + "konsep=" + konsep + "&";
		}
		if (definisi) {
			url = url + "definisi=" + definisi + "&";
		}
		if (klasifikasi) {
			url = url + "klasifikasi=" + klasifikasi + "&";
		}
		if (ukuran) {
			url = url + "ukuran=" + ukuran + "&";
		}
		if (satuan) {
			url = url + "satuan=" + satuan + "&";
		}
		if (flag) {
			url = url + "flag=" + flag + "&";
		}
		if (page != null) {
			url = url + "page=" + page + "&";
		}
		if (size != null) {
			url = url + "size=" + size;
		}
		if (sortBy != null && sortBy.length > 0) {
			url = url + "&sortBy="
			sortBy.forEach((x, index) => {
				if (index != sortBy.length - 1) {
					url = url + x.property + '-' + x.direction + ",";
				} else {
					url = url + x.property + '-' + x.direction;
				}

			});
		}
		return axios.get(url, {
			headers: headers(),
		});
	}

	getSdsn2022List(kodeSds, namaData, konsep, definisi, klasifikasiPenyajian, klasifikasiIsian, ukuran, satuan, tipe, page, size, sortBy) {
		let url = '/api/standar-data-statistik-nasional-2023?'
		if (kodeSds) {
			url = url + "kodeSds=" + kodeSds + "&";
		}
		if (namaData) {
			url = url + "namaData=" + namaData + "&";
		}
		if (konsep) {
			url = url + "konsep=" + konsep + "&";
		}
		if (definisi) {
			url = url + "definisi=" + definisi + "&";
		}
		if (klasifikasiPenyajian) {
			url = url + "klasifikasiPenyajian=" + klasifikasiPenyajian + "&";
		}
		if (klasifikasiIsian) {
			url = url + "klasifikasiIsian=" + klasifikasiIsian + "&";
		}
		if (ukuran) {
			url = url + "ukuran=" + ukuran + "&";
		}
		if (satuan) {
			url = url + "satuan=" + satuan + "&";
		}
		if (tipe) {
			url = url + "tipe=" + tipe + "&";
		}
		if (page != null) {
			url = url + "page=" + page + "&";
		}
		if (size != null) {
			url = url + "size=" + size;
		}
		if (sortBy != null && sortBy.length > 0) {
			url = url + "&sortBy="
			sortBy.forEach((x, index) => {
				if (index != sortBy.length - 1) {
					url = url + x.property + '-' + x.direction + ",";
				} else {
					url = url + x.property + '-' + x.direction;
				}

			});
		}
		return axios.get(url, {
			headers: headers(),
		});
	}
	
	getUserByOrganizationId(OrganizationId) {
		let url = '/api/organization/' + OrganizationId + '/users?role=ROLE_SDS_PRODUSEN_DATA';
		return axios.get(url, {
			headers: headers(),
		});
	}
	getSubmissionSummaries(submissionPeriod, produsenDataId, requestedBy){
		let url = '/api/standar-data-statistik/usulan/items/summaries?submissionPeriod='+submissionPeriod+'&produsenDataId='+produsenDataId+'&requestedBy='+requestedBy;
		return axios.get(url, {
			headers: headers(),
		});
	} 

	/* getSdsItemSummaryByRequester(username, submissionPeriod){
		let url = '/api/standar-data-statistik/usulan/items/requester-summaries?username=' + username +'&submissionPeriod='+submissionPeriod;
		return axios.get(url, {
			headers: headers(),
		});
	} */
	getAppprovalSummaries(username, submissionPeriod){
		let url = '/api/standar-data-statistik/usulan/items/approver-summaries?username=' + username +'&submissionPeriod='+submissionPeriod;
		return axios.get(url, {
			headers: headers(),
		});
	}
	getSdsItemSummaryByBpsDivision(submissionPeriod) {
		let url = '/api/standar-data-statistik/usulan/items/bps-division-summaries?submissionPeriod='+submissionPeriod;
		return axios.get(url, {
			headers: headers(),
		});
	}
	getSdsItemSummaryByWalidata(submissionPeriod) {
		let url = '/api/standar-data-statistik/usulan/items/walidata-summaries?submissionPeriod='+submissionPeriod;
		return axios.get(url, {
			headers: headers(),
		});
	}
	getSdsItemSummaryByProdusenData(submissionPeriod) {
		let url = '/api/standar-data-statistik/usulan/items/produsen-data-summaries?submissionPeriod='+submissionPeriod;
		return axios.get(url, {
			headers: headers(),
		});
	}
	getSdsItemSummaryByRequester(submissionPeriod) {
		let url = '/api/standar-data-statistik/usulan/items/requester-summaries?submissionPeriod='+submissionPeriod;
		return axios.get(url, {
			headers: headers(),
		});
	}
	getSdsItemSummaryByApprover(submissionPeriod) {
		let url = '/api/standar-data-statistik/usulan/items/approver-summaries?submissionPeriod='+submissionPeriod;
		return axios.get(url, {
			headers: headers(),
		});
	}
}

export default new SdsService();
